import { DaoService } from "./DaoService";

export default class ActiviteService extends DaoService {
  static getInstance() {
    return super.getInstance("activite");
  }

  async findAll(parentId, target) {
    return ActiviteService.get(`${this.prefix}/${parentId}/${target}`);
  }

  async search(data) {
    return ActiviteService.post(`${this.prefix}/search`, data);
  }

  async switchDone(uid) {
    return ActiviteService.post(`${this.prefix}/${uid}/switch-done`);
  }

  async update(uid, data) {
    return ActiviteService.put(`${this.prefix}/${uid}`, data);
  }

  async findByParent(parentId, parentType, extraParams = {}) {
    const data = { parent_type: parentType, ...extraParams };
    return ActiviteService.post(`${this.prefix}/${parentId}/parent`, data);
  }

}
